import { render, staticRenderFns } from "./enterprisesCityRelation.vue?vue&type=template&id=3ff9f8ce&scoped=true&"
import script from "./enterprisesCityRelation.vue?vue&type=script&lang=js&"
export * from "./enterprisesCityRelation.vue?vue&type=script&lang=js&"
import style0 from "./enterprisesCityRelation.vue?vue&type=style&index=0&id=3ff9f8ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff9f8ce",
  null
  
)

export default component.exports